import {Component, Input, OnInit, OnDestroy, Renderer2, ElementRef, Directive} from '@angular/core';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {LotteriesService} from '../../lotteries.service';
import {Subscription} from 'rxjs';
import {SubscriptionsService} from '../../_services/subscriptions.service';
import {UserService} from '../../_services/user.service';
import {Router} from '@angular/router';
import * as globals from '../../settings';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss', './footer.mobile.component.scss']
})
export class FooterComponent implements OnInit, OnDestroy {
    showLang: any;
    languageChange: any;
    toggleScratchContent: Subscription;
    affiliate: Subscription;
    getSuccessAddPaymentMethodStatus: Subscription;
    triggerPixel: Subscription;
    triggerPayment: Subscription;
    toggleContent: boolean;
    showSuccessPaymentMethod: boolean;
    isMobile: boolean;
    user: any;
    isSafari: boolean;
    @Input() doNotShow: any;
    brand = globals.brand;


    constructor(private translate: TranslateService,
                public lotteryService: LotteriesService,
                private renderer: Renderer2,
                private subscriptionsService: SubscriptionsService,
                public userService: UserService, private el: ElementRef, public router: Router) {
        const navigatorUa = navigator.userAgent.toLowerCase();
        this.isSafari = false;
        if (navigatorUa.indexOf('safari') !== -1) {
            if (navigatorUa.indexOf('chrome') === -1) {
                this.isSafari = true;
            }
        }
        this.userService.getUser();
        this.showLang = '/' + localStorage.getItem('pageLanguage');
        this.toggleScratchContent = this.subscriptionsService.getToggleContent().subscribe( data => {
            if ( this.lotteryService.isMobile) {
                if (this.toggleContent !== data) {
                    this.toggleContent = data;
                }
            }
        });

        this.getSuccessAddPaymentMethodStatus = this.subscriptionsService.getShowSuccessPaymentMethodStatus().subscribe( data => {
            this.showSuccessPaymentMethod = true;
            setTimeout(() => {
                this.showSuccessPaymentMethod = false;
            }, 3500);
        });


        this.triggerPayment = this.subscriptionsService.getFirstTimeAffiliate().subscribe(data => {
            // this.renderer.addClass(document.body, 'casinoRoyale');
            const orderData = JSON.parse(localStorage.getItem('affiliateData'));
            const div = this.renderer.createElement('div');
            this.renderer.setProperty(div, 'id', 'isFTD');
            this.renderer.setAttribute(div, 'data-orderID', orderData.OrderID ? 'deposit' : 'deposit');
            this.renderer.setAttribute(div, 'data-orderPrice', orderData.Price ? 'deposit' : 'deposit');
            this.renderer.setAttribute(div, 'data-orderCurrency', orderData.PriceCurrency ? 'deposit' : 'deposit');
            this.renderer.appendChild(this.el.nativeElement, div);
        });

        this.triggerPixel = this.subscriptionsService.getRegistrationFirstTime().subscribe(data => {
            if (data) {
                this.user = JSON.parse(localStorage.getItem('playerDetails'));
                    const registerPixel = this.renderer.createElement('div');
                    this.renderer.setProperty(registerPixel, 'id', 'register-success');

                    this.renderer.appendChild(this.el.nativeElement, registerPixel);
                    setTimeout(() => {
                        this.renderer.setStyle(registerPixel, 'display', 'none');
                    }, 50000);
                }
        });
    }

    ngOnInit() {
        this.toggleContent = true;
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            if (event.lang !== 'undefined') {
                this.showLang = '/' + event.lang;
            }
        });
    }

    ngOnDestroy() {
         if (this.toggleScratchContent) {  this.toggleScratchContent.unsubscribe(); }
         if (this.triggerPayment) {
             this.triggerPayment.unsubscribe();
         }
    }

    hashCode(str: any) {
        return str.split('').reduce((prevHash, currVal) =>
            (((prevHash << 5) - prevHash) + currVal.charCodeAt(0)) | 0, 0).toString();
    }

}
